<div
  class="dashboard-material-theme dashboard-confirmation-dialog"
  fxLayout="column"
  fxLayoutAlign="space-between center"
>
  <mat-dialog-content class="dashboard-confirmation-dialog__content">
    {{ data.title || 'Are you sure?' }}</mat-dialog-content
  >
  <br />
  <mat-dialog-content *ngIf="data?.text">{{ data?.text }} <br /><br /></mat-dialog-content>
  <mat-dialog-actions class="dashboard-confirmation__actions" fxLayout="row" fxLayoutAlign="end center" fxFill>
    <button mat-button (click)="onReject()">{{ 'Cancel' | uppercase }}</button>
    <button mat-button color="warn" [mat-dialog-close]="true" (click)="onConfirm()">
      {{ 'Confirm' | uppercase }}
    </button>
  </mat-dialog-actions>
</div>
